import { useEffect } from "react";

type MetaInput = {
  title: string;
  description: string;
};

const fallbackDescription =
  "Hangar Muhendislik: celik konstruksiyon, fabrika, hangar ve depo projelerinde anahtar teslim muhendislik cozumleri.";

export function usePageMeta({ title, description }: MetaInput) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || fallbackDescription);

    const ogTitle = setOrCreateMeta("property", "og:title");
    ogTitle.setAttribute("content", title);

    const ogDescription = setOrCreateMeta("property", "og:description");
    ogDescription.setAttribute("content", description || fallbackDescription);
  }, [title, description]);
}

function setOrCreateMeta(attrKey: string, attrValue: string) {
  let meta = document.querySelector(`meta[${attrKey}="${attrValue}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attrKey, attrValue);
    document.head.appendChild(meta);
  }
  return meta;
}
